import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { AuthShell, Input } from "@/pages/Login";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await forgotPassword(email); setSent(true); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="WACHTWOORD VERGETEN" subtitle="We sturen je een link om je wachtwoord opnieuw in te stellen.">
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <MailCheck className="mx-auto mb-3 h-12 w-12 text-[#22C55E]" />
          <p className="text-[#cfcfcf]">Als dit e-mailadres bij ons bekend is, ontvang je binnen enkele minuten een reset-link.</p>
          <Link to="/inloggen" className="mt-4 inline-block font-semibold text-[#FF6A00] hover:underline">Terug naar inloggen</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          {error && <p className="rounded-lg border border-[#EF4444]/40 bg-[#EF4444]/10 p-3 text-sm text-[#EF4444]">{error}</p>}
          <Input label="E-mail" type="email" value={email} onChange={setEmail} testid="forgot-email" />
          <button type="submit" disabled={loading} data-testid="forgot-submit" className="flex w-full items-center justify-center gap-2 rounded-full bg-[#FF6A00] py-3.5 font-bold text-[#111] hover:bg-[#FFB27A] active:scale-95 disabled:opacity-60">{loading && <Loader2 className="h-5 w-5 animate-spin" />} Verstuur reset-link</button>
          <p className="text-center text-sm text-[#A0A0A0]"><Link to="/inloggen" className="font-semibold text-[#FF6A00] hover:underline">Terug naar inloggen</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
